import {
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  TooltipContent,
  TooltipTrigger,
  DropdownMenu,
  Typography,
  ColumnDef,
  Tooltip,
  Button,
  toast,
} from '@ui/components';
import { useHasPermission, useGetFile } from '@shared/hooks';
import { MenuVertical } from '@ui/components/icons';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';

// Index of invoice path in the row
const INVOICE_PATH_INDEX = 13;

export function InvoicingActionColumn<T>(): ColumnDef<T[]> {
  const { t } = useTranslation();
  const hasPermission = useHasPermission('REPORTS_FILES_DOWNLOAD_INVOICE_AND_ATTACHMENTS', 'WRITE');
  const { handleGetFile } = useGetFile({
    onSuccess: () => {
      toast.success(t('CELL_TEMPLATES.DOWNLOAD_SUCCESS'));
    },
  });

  return {
    id: 'actions',
    accessorKey: 'actions',
    header: '',
    size: 60,
    cell: ({ row }) => {
      const invoiceRow = row.original[INVOICE_PATH_INDEX];
      const [bucketName, objectName] = (invoiceRow as string).split('|');

      return (
        <div className="flex justify-end">
          <HasPermission permissionFeature="PARKINGS_STOP_PARKING" permissionType="WRITE">
            <DropdownMenu>
              <Tooltip>
                <TooltipTrigger tabIndex={-1} asChild>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost">
                      <MenuVertical />
                    </Button>
                  </DropdownMenuTrigger>
                </TooltipTrigger>
                <TooltipContent className="w-auto">
                  <Typography variant="labelXSmallBook">
                    {t('FILES_REPORTS.INVOICING.TABLE.MORE')}
                  </Typography>
                </TooltipContent>
              </Tooltip>
              <DropdownMenuContent className="w-56">
                <DropdownMenuItem
                  onClick={() => {
                    if (bucketName && objectName) {
                      handleGetFile({ objectName, bucketName });
                    }
                  }}
                  disabled={!bucketName || !objectName || !hasPermission}
                >
                  {t('FILES_REPORTS.INVOICING.TABLE.DOWNLOAD_INVOICE')}
                </DropdownMenuItem>
                {/* TODO: It's not ready on BE */}
                {/* <DropdownMenuItem
                  onClick={() => {
                    // IMPORTANT: Opensearch returns us data in specific order. Document name is the second element in the array.
                    const documentName = row.original[1] as string;

                    onOpenDrawer({
                      invoiceId: row.id,
                      invoiceName: documentName,
                    });
                  }}
                >
                  {t('FILES_REPORTS.INVOICING.TABLE.SHOW_RECIPIENTS')}
                </DropdownMenuItem> */}
              </DropdownMenuContent>
            </DropdownMenu>
          </HasPermission>
        </div>
      );
    },
  };
}
